import PrimaryButton from "../../widgets/Buttons/PrimaryButton";
import PasswordTextfield from "../../widgets/Textfield/PasswordTextfield";
import Textfield from "../../widgets/Textfield/Textfield";
import { DEFAULT_ISD_CODE } from "../../constants/constants";
import { getPhoneConfigForIsd } from "../../constants/phoneConfig";

const LoginForm = ({
  values,
  setFieldValue,
  onSubmit,
  isValid,
  errors,
  touched,
  handleBlur,
  dirty,
  isLoading,
}) => {
  const getHelperText = (field, requiredMsg) => {
    if (!touched[field]) return "";
    if (!values[field]) return requiredMsg;
    return errors[field] || "";
  };

  const getError = (field) => {
    if (!touched[field]) return false;
    if (!values[field]) return true;
    return Boolean(errors[field]);
  };

  const maxPhoneLength = getPhoneConfigForIsd(DEFAULT_ISD_CODE).maxLength;

  return (
    <form onSubmit={onSubmit} className="login-form">
      <Textfield
        id="phone"
        name="phone"
        label="Phone Number"
        type="tel"
        autoComplete="tel"
        value={values.phone}
        handleOnChange={(event) =>
          setFieldValue(
            "phone",
            event.target.value.replace(/\D/g, "").slice(0, maxPhoneLength),
          )
        }
        onBlur={handleBlur}
        error={getError("phone")}
        helperText={getHelperText("phone", "Phone number is required")}
        disabled={isLoading}
      />

      <PasswordTextfield
        id="password"
        name="password"
        label="Password"
        autoComplete="current-password"
        value={values.password}
        onChange={(e) => setFieldValue("password", e.target.value)}
        onBlur={handleBlur}
        error={getError("password")}
        helperText={getHelperText("password", "Password is required")}
        disabled={isLoading}
      />

      <PrimaryButton type="submit" disabled={!isValid || !dirty} isLoading={isLoading}>
        LOGIN
      </PrimaryButton>
    </form>
  );
};

export default LoginForm;
